import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import { useParamsContext } from "../../../../../context/juno/ParamsContext";

const Quality = () => {
  const { t } = useTranslation();
  const { quality, setQuality, aiEngine } = useParamsContext();

  return (
    <>
      {["GPTImage1", "IdeogramV3", "IdeogramV3Remix", "IdeogramV3ReplaceBackground", "IdeogramV3Edit"].includes(
        aiEngine!
      ) && (
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", mb: 2 }} gap={1}>
          <FormControl fullWidth>
            <InputLabel id="quality-select-label">{t("juno.input.quality.title")}</InputLabel>
            <Select
              size={"small"}
              value={quality[aiEngine!] || "medium"}
              label={t("juno.input.quality.title")}
              onChange={(event) => {
                const newValue = event.target.value as string;
                setQuality({ ...quality, [aiEngine!]: newValue });
              }}
            >
              <MenuItem value="high">{t("juno.input.quality.high")}</MenuItem>
              <MenuItem value="medium">{t("juno.input.quality.medium")}</MenuItem>
              <MenuItem value="low">{t("juno.input.quality.low")}</MenuItem>
            </Select>
          </FormControl>
        </Box>
      )}
    </>
  );
};
export default Quality;
